import { render, staticRenderFns } from "./DocumentsViewer.vue?vue&type=template&id=8b1935b6&scoped=true&ref=documentsViewer&"
import script from "./DocumentsViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1935b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
